module.exports = __webpack_public_path__ + "c715e472a42e02b8590bcf2d093fcff8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/fire.png
// module id = 2746
// module chunks = 0